export const inflect = (t, word, form) => {
    return t(`inflection:${word}.${form}`, word)
}
